import ConfirmDialog from "../../../components/customHelpers/ConfirmDialog";
import Controls from "../../../components/controls/Controls";
import Loading from "../../../components/customHelpers/Loading";

import Layout from "../../../components/layout/Layout";
import { TableBody, TableRow, TableCell, Typography } from "@material-ui/core";

import { Grid } from "@material-ui/core";
import { useEffect, useMemo, useState } from "react";

import { MdOutlineDelete } from "react-icons/md";
import { IoMdAdd } from "react-icons/io";
import useTable from "../../../components/customHelpers/useTable";
import Notify from "../../../components/customHelpers/Notify";
import Notification from "../../../components/customHelpers/Notification";
import Product from "../../../actions/product";
import Order from "../../../actions/order";
import UpdateOrderProductForm from "../../../components/forms/orderProduct";
import Popup from "../../../components/customHelpers/Popup";
import produce from "immer";
import Box from "@mui/material/Box";
import { useHistory, useLocation } from "react-router-dom";
import CustomerDetails from "./orderProfiel";
import {
  Autocomplete,
  Checkbox,
  FormControlLabel,
  FormGroup,
  MenuItem,
  TextareaAutosize,
  TextField,
} from "@mui/material";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { formatNumber, updatePrices } from "../../../utils/utils";
import CustomerOrder from "./CustomerOrders";
import { useOrderManagement } from "./useOrderManagement";
const headCells = [
  { id: "name", label: "Product Name" },
  { id: "store", label: "Store" },
  { id: "sku", label: "Sku" },
  { id: "quantity", label: "Quantity" },
  { id: "price", label: "Price" },
  { id: "disount", label: "Discount" },
  { id: "totalPrice", label: "Total Price" },
  { id: "updatedAt", label: "UpdatedAt" },
  { id: "actions", label: "Actions", disableSorting: true },
];
const ProductDetailPage = () => {
  useEffect(() => {
    getAllProducts();
  }, []);
  const [orderStatus, setOrderStatus] = useState("");
  const history = useHistory();
  const [filteredProducts, setFilteredProducts] = useState([]);
  const { NotifyMessage, notify, setNotify } = Notify();
  const { viewOrder, deleteOrder, updateOrderStatus } = Order();
  const { viewAllProductsLists, updateProductList } = Product();
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [edite, setEdit] = useState(false);
  const [productData, setProductData] = useState(null);
  const [productLists, setProductLists] = useState([]);
  const [clicked, setClicked] = useState(false);
  const [values, setValues] = useState({
    loading: false,
    reload: false,
  });
  const { loading, reload } = values;
  let location = useLocation();
  const value = location.pathname.split("/").filter((x) => x)[
    location.pathname.split("/").filter((x) => x).length - 1
  ];
  useEffect(() => {
    getOrderData();
  }, [value]);
  useEffect(() => {
    if (productData) {
      setOrderStatus(productData.status);
      setRemark(productData.remark);
    }
  }, [productData]);
  const getOrderData = () => {
    viewOrder(value).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.orders) {
        setValues({
          ...values,
          loading: false,
        });
        setProductLists(data.orders.orderProducts);
        setProductData(data.orders);
        setPaid(data.orders.paid);
        setRemark(productData?.remark);
      }
    });
  };
  const getOrderDataTemp = () => {
    viewOrder(value).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.orders) {
        setValues({
          ...values,
          loading: false,
        });
        setProductLists(data.orders.orderProducts);
        setProductData(data.orders);
        setPaid(data.orders.paid);
      }
    });
  };
  const handleSearchInputChange = (event) => {
    let input = event.target.value;

    if (event) {
      const filtered = products.filter(
        (data) =>
          data.product?.name.toLowerCase().includes(input.toLowerCase()) ||
          data.product?.sku.toLowerCase().includes(input.toLowerCase())
      );
      setFilteredProducts(filtered);
    } else {
      setFilteredProducts([]);
    }
  };
  const [paid, setPaid] = useState("");
  const [unpaid, setUnpaid] = useState("");
  const [productId, setProdcutId] = useState();
  const [price, setPrice] = useState("");
  const [productName, setProductName] = useState();
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [store, setStore] = useState();
  const [sku, setSku] = useState();
  const [inputValue, setInputValue] = useState("");
  const [quantityError, setQuantityError] = useState("");
  const [discountValue, setDiscountValue] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [warning, setWarning] = useState("");

  const [isPercentDiscount, setIsPercentDiscount] = useState(false);
  const [qt, setQt] = useState(0);
  const [productQuantity, setProductQuantity] = useState(0);

  const handleChangeQt = (e) => {
    const value = Number(e.target.value);
    if (productQuantity && value > productQuantity) {
      setQuantityError("Quantity exceeds available stock");
    } else {
      setQuantityError("");
    }
    setQt(e.target.value);
  };
  const onChangeProductList = (event) => {
    if (event) {
      setProductName(event.product.name);
      setProdcutId(event.id);
      setProductQuantity(event.quantity);
      setPrice(event.price);
      setStore(event.store?.locationName);
      setSku(event.product.sku);
    }
    setSelectedProduct(event);
  };
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(productLists, headCells, filterFn);

  const onDelete = (deleted, quantity) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
    deleteOrder(deleted).then((data) => {
      if (data.err) {
        if (data.err !== "order is not found!") {
          NotifyMessage({
            message: data.err,
            type: "error",
          });
        }
        if (data.err === "order is not found!") {
          setProductLists(
            produce(productLists, (draft) => {
              const index = productLists.findIndex(
                (item) =>
                  item.product === deleted.product &&
                  Number(item.price.trim()) === Number(deleted.price.trim()) &&
                  Number(item.discount) === Number(deleted.discount)
              );
              if (index !== -1) draft.splice(index, 1);
            })
          );
        }
        const updatedProducts = products.map((product) =>
          product.id === deleted.product
            ? {
                ...product,
                quantity: Number(product.quantity) + Number(quantity),
              }
            : product
        );

        setProducts(updatedProducts);
      } else {
        NotifyMessage({
          message: data.message,
          type: "success",
        });
        setValues({ ...values, reload: !reload });
        getAllProducts();
        getOrderDataTemp();
      }
    });
  };
  const handleQuantityChange = (productId, newQuantity) => {
    const existingProduct = productLists.find((item) => item.id === productId);

    if (existingProduct && newQuantity > existingProduct.quantity) {
      setQuantityError(
        `Quantity exceeds available stock! (${existingProduct.quantity} available)`
      );
    }
    setProductLists((prevOrders) => {
      const updatedOrders = prevOrders.map((order) => {
        if (order.id === productId || order.product === productId) {
          return {
            ...order,
            quantity: newQuantity,
            totalPrice: newQuantity * order.price,
          };
        }
        return order;
      });
      setProductLists(updatedOrders);
      return updatedOrders;
    });
  };
  const [products, setProducts] = useState([]);
  const { updateOrder } = Order();

  const getAllProducts = () => {
    viewAllProductsLists().then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.product) {
        setProducts(updatePrices(data.product));
      }
    });
  };

  const updateProductPrice = () => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
    updateProductList({ price: price }, selectedProduct.id).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else {
        NotifyMessage({
          message: "Product Price successfully updated",
          type: "success",
        });
        updatePrice(selectedProduct.id, price);
      }
    });
  };
  const updatePrice = (id, newPrice) => {
    setProducts((products) =>
      products.map((item) =>
        item.id === id ? { ...item, price: newPrice } : item
      )
    );
  };
  const saveData = () => {
    setClicked(true);
    if (selectedProduct.price !== price) {
      setConfirmDialog({
        isOpen: true,
        title: "Are you sure to update the inventory price?",
        onConfirm: () => {
          updateProductPrice();
        },
      });
    }
    const existingProductIndex = productLists.findIndex(
      (item) =>
        item.product === productId &&
        Number(item.price.trim()) === Number(price.trim()) &&
        Number(item.discount) === Number(discount)
    );
    const existingItem = productLists.find(
      (item) =>
        item.product === productId &&
        Number(item.price.trim()) === Number(price.trim()) &&
        Number(item.discount) === Number(discount)
    );
    const quantityToAdd = Number(qt);
    if (existingItem) {
      const updatedData = productLists.map((item, index) =>
        index === existingProductIndex
          ? {
              ...item,
              quantity: Number(item.quantity) + quantityToAdd,
              totalPrice:
                discount > 0
                  ? calculateItemTotal.toFixed(2) *
                    (Number(item.quantity) + quantityToAdd)
                  : (Number(item.quantity) + quantityToAdd) * item.price, // Use the updated quantity
            }
          : item
      );
      setProductLists(updatedData);
    } else {
      let totalPrice = quantityToAdd * price;
      if (discount > 0) {
        totalPrice = calculateItemTotal.toFixed(2);
      }
      setProductLists([
        ...productLists,
        {
          product: productId,
          discount: discountValue,
          price: price,
          store: store,
          sku: sku,
          totalPrice: totalPrice,
          quantity: qt,
          productName: productName,
        },
      ]);
    }
    const updatedProducts = products.map((product) =>
      product.id === productId
        ? { ...product, quantity: product.quantity - quantityToAdd }
        : product
    );
    setProducts(updatedProducts);
    setPrice("");
    setQt(0);
    setProdcutId(null);
    setProductName(null);
    setSelectedProduct(null);
    setInputValue("");
    setDiscount(0);
  };
  const calculateItemTotal = useMemo(() => {
    if (isPercentDiscount) {
      const totalPriceWithoutDiscount = price * qt;
      const discountAmount = (price * discount * qt) / 100;
      setDiscountValue(discountAmount);
      return totalPriceWithoutDiscount - discountAmount;
    } else {
      setDiscountValue(discount);
      return (price - discount) * qt;
    }
  }, [isPercentDiscount, discount, price, qt]);
  const handlePaidChange = (event) => {
    const newPaid = parseFloat(event.target.value) || 0;
    if (/^\d*\.?\d*$/.test(newPaid)) {
      setPaid(newPaid);
      const totalPrice = calculateTotalPrice();
      const remaining = totalPrice - newPaid;
      setUnpaid(remaining);
    }
  };

  const calculateTotalPrice = () => {
    let totalPrice = 0;
    if (productLists.length > 0) {
      productLists.forEach((order) => {
        totalPrice += parseFloat(order.totalPrice) || 0; // Ensure each totalPrice is treated as a number
      });
    }
    return totalPrice.toFixed(2); // Return the total price rounded to 2 decimal places
  };

  const handleSubmit = () => {
    // e.preventDefault();
    let orderData = {
      items: productLists,
      remark: remark,
      paid: paid,
    };
    setValues({ ...values, submitting: true });
    updateOrder(orderData, value).then((data) => {
      if (data.err) {
        setValues({ ...values, submitting: false });
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.order) {
        history.push(`/print/${value}`);
        setValues({ ...values, submitting: false });
        NotifyMessage({
          message: "Order  successfully updated",
          type: "success",
        });
      }
    });
  };

  const handleCache = () => {
    let item;
    const existingProductIndex = productLists.findIndex(
      (item) => item.product === productId
    );
    const quantityToAdd = Number(qt);

    if (existingProductIndex !== -1) {
      const updatedData = productLists.map((item, index) =>
        index === existingProductIndex
          ? {
              ...item,
              quantity: Number(item.quantity) + quantityToAdd,
              totalPrice: (item.quantity + quantityToAdd) * item.price,
            }
          : item
      );
      item = updatedData;
    } else {
      item = [
        ...productLists,
        {
          product: productId,
          price: price,
          store: store,
          sku: sku,
          totalPrice: qt * price,
          quantity: qt,
          productName: productName,
        },
      ];
    }
    const updatedProducts = products.map((product) =>
      product.id === productId
        ? { ...product, quantity: product.quantity - quantityToAdd }
        : product
    );
    setProducts(updatedProducts);
    let orderData = {
      items: item,
      remark: remark,
      paid: paid,
    };
    setValues({ ...values, submitting: true });
    updateOrder(orderData, value).then((data) => {
      if (data.err) {
        setValues({ ...values, submitting: false });
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.order) {
        setValues({ ...values, submitting: false });

        history.push(`/print/${value}`);
        NotifyMessage({
          message: "Role successfully updated",
          type: "success",
        });
      }
    });
  };
  const [remark, setRemark] = useState("");

  const handleChange = (event) => {
    setRemark(event.target.value);
  };

  const handleDiscountChange = (e) => {
    const newDiscount = Number(e.target.value);
    setDiscount(newDiscount);
    setWarning("");
    if (isPercentDiscount) {
      if (newDiscount > 100) {
        setWarning("Discount percentage cannot exceed 100%.");
      }
    } else if (newDiscount > price) {
      setWarning("Discount cannot exceed item price.");
    }

    if (isPercentDiscount) {
      const discountAmount = (price * newDiscount) / 100;
      setDiscountValue(discountAmount);
    } else {
      setDiscountValue(newDiscount);
    }
  };

  const { orders, filterOrdersByProductId, groupByStatusAndSumQuantities } =
    useOrderManagement();

  const filteredResults = filterOrdersByProductId(sku);
  const summedResults = groupByStatusAndSumQuantities(filteredResults);
  return (
    <Layout>
      <div className="card">
        <Typography variant="h6">
          <ArrowBackIcon
            style={{ cursor: "pointer" }}
            onClick={() => {
              history.push("/orders");
            }}
          ></ArrowBackIcon>{" "}
          <span style={{ marginLeft: "6px" }}>Order Detail</span>
        </Typography>{" "}
        {productData && (
          <Box display="flex" justifyContent="space-between">
            <div>
              <CustomerDetails
                title="Customer"
                change="true"
                id={value}
                product={productData}
                getOrderData={getOrderData}
              ></CustomerDetails>
            </div>
            <Box>
              <CustomerOrder id={productData?.customer?.id} />
            </Box>
          </Box>
        )}
        <Box display="flex" justifyContent="flex-end">
          <TextField
            id="outlined-select-currency"
            disabled
            label="Select Status"
            sx={{ width: "15%" }}
            value={orderStatus}
          ></TextField>
        </Box>
        <Grid container>
          <Grid item xs={12} className="card__body">
            {loading ? (
              <Loading />
            ) : (
              <>
                <TblContainer>
                  <TblHead />
                  <TableBody>
                    {recordsAfterPagingAndSorting().length > 0
                      ? recordsAfterPagingAndSorting().map((item) => (
                          <TableRow key={item.id}>
                            <TableCell>{item.productName}</TableCell>
                            <TableCell>{item.store}</TableCell>
                            <TableCell>{item.sku}</TableCell>
                            <TableCell>{item.quantity}</TableCell>
                            <TableCell>{item.price}</TableCell>
                            <TableCell>
                              {item.discount ? item.discount : 0}
                            </TableCell>
                            <TableCell>{item.totalPrice}</TableCell>
                            <TableCell>
                              {item.updatedAt
                                ? new Date(item.updatedAt).toLocaleString()
                                : new Date().toLocaleString()}
                            </TableCell>

                            <TableCell>
                              <Controls.ActionButton
                                color="secondary"
                                title="Delete"
                                onClick={() => {
                                  setConfirmDialog({
                                    isOpen: true,
                                    title:
                                      "Are you sure to delete this Order Product?",
                                    subTitle: "You can't undo this operation",
                                    onConfirm: () => {
                                      onDelete(
                                        item.id ? item.id : item,
                                        item.quantity
                                      );
                                    },
                                  });
                                }}
                              >
                                <MdOutlineDelete fontSize="medium" />
                              </Controls.ActionButton>
                            </TableCell>
                          </TableRow>
                        ))
                      : null}
                  </TableBody>
                </TblContainer>
                <TblPagination />
              </>
            )}
          </Grid>
        </Grid>
        {products.length > 0 && (
          <Box display="flex" justifyContent="flex-end" m={1} p={1}>
            <Box p={1} sx={{ width: "40%" }}>
              <Autocomplete
                options={
                  filteredProducts.length === 0
                    ? products.filter((option) => option.quantity > 0)
                    : filteredProducts.filter((option) => option.quantity > 0)
                }
                getOptionLabel={(option) =>
                  `${option.product?.name}  -  ${option.product?.sku} - ${
                    option.quantity
                  }  -  ${
                    option.store?.locationName ? option.store?.locationName : ""
                  }`
                }
                loading={products.length === 0}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Search for a Product"
                    variant="outlined"
                    fullWidth
                    onChange={handleSearchInputChange}
                  />
                )}
                onInputChange={(event, newInputValue) =>
                  setInputValue(newInputValue)
                }
                value={selectedProduct} // Set the selected value
                inputValue={inputValue}
                onChange={(event, newValue) => onChangeProductList(newValue)}
              />

             
{selectedProduct && (
                    <div>
                      {summedResults.length > 0 ? (
                        <>
                          {summedResults.map((result, index) => (
                            <div key={index}>
                              <span>{result.status} - </span>
                              <span>{result.totalQuantity}</span>
                            </div>
                          ))}
                        </>
                      ) : (
                        <div>
                          <div>Orderd: 0</div>
                          <div>Pending : 0</div>
                        </div>
                      )}
                    </div>
                  )}
            </Box>

            <Box p={1}>
              <TextField
                id="outlined-basic"
                value={qt}
                type="number"
                onChange={handleChangeQt}
                label="Quantity"
                fullWidth
                variant="outlined"
                error={Boolean(quantityError)} // Show error state if there's an error message
                helperText={quantityError}
              />
            </Box>

            <Box p={1}>
              <TextField
                id="outlined-basic"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                label="Item Price"
                type="number"
                fullWidth
                variant="outlined"
              />
            </Box>

            <Box sx={{ width: "16%" }}>
              <TextField
                style={{ marginTop: "8px" }}
                id="outlined-basic"
                label="Discount"
                fullWidth
                variant="outlined"
                value={discount}
                error={!!warning}
                helperText={warning}
                onChange={handleDiscountChange}
              />

              <FormGroup style={{ marginLeft: "12px" }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isPercentDiscount}
                      onChange={(e) => setIsPercentDiscount(e.target.checked)}
                    />
                  }
                  label="Percent"
                />
              </FormGroup>
            </Box>
            <Box p={1}>
              {discount > 0 && calculateItemTotal ? (
                <TextField
                  id="outlined-basic"
                  value={qt > 0 && price ? calculateItemTotal.toFixed(2) : 0}
                  label="Item Total Price"
                  fullWidth
                  variant="outlined"
                  disabled
                />
              ) : (
                <TextField
                  id="outlined-basic"
                  value={qt > 0 && price ? price * qt : 0}
                  label="Item Total Price"
                  fullWidth
                  variant="outlined"
                  disabled
                />
              )}
            </Box>
            <Box p={1} sx={{ width: "10%" }}>
              {quantityError || qt === 0 || qt < 0 ? null : (
                <Controls.Button
                  text="Add"
                  size="small"
                  variant="outlined"
                  startIcon={<IoMdAdd />}
                  className="Button"
                  onClick={saveData}
                />
              )}
            </Box>
          </Box>
        )}
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
          }}
        >
          <TextareaAutosize
            aria-label="minimum height"
            minRows={7}
            placeholder="Remark"
            value={remark}
            onChange={handleChange}
            style={{
              width: 400,
              padding: "8px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              resize: "both",
            }}
          />

          <Box
            sx={{
              display: "flex",
              alignItems: "flex-end",
              flexDirection: "column",
              p: 1,
              m: 1,
              bgcolor: "background.paper",
              borderRadius: 1,
            }}
          >
            {calculateTotalPrice() && (
              <Box p={1}>
                <div
                  style={{
                    marginRight: "35px",
                    fontWeight: "bold",
                    fontSize: "15px",
                  }}
                >
                  Total Price: {calculateTotalPrice()}
                </div>
              </Box>
            )}
            <Box p={1}>
              <TextField
                variant="outlined"
                label="Paid"
                value={paid}
                fullWidth
                type="number"
                onChange={handlePaidChange}
                inputProps={{
                  step: "0.01",
                  min: "0",
                  title: "Please enter a valid number",
                }}
              />
            </Box>
            {calculateTotalPrice() > 0 && (
              <Box p={1}>
                <Controls.Input
                  label="Balance"
                  disabled
                  value={(calculateTotalPrice() - paid).toFixed(2)}
                />
              </Box>
            )}
            <Box p={1}>
              <Controls.Button
                disabled={
                  values.submitting || products.length === 0 ? true : false
                }
                text={"Cancel"}
                variant="contained"
                className="Button"
                onClick={() => {
                  history.push(`/print/${value}`);
                }}
                type="submit"
              />
              {productId || selectedProduct ? (
                <Controls.Button
                  disabled={
                    values.submitting || products.length === 0 ? true : false
                  }
                  text={values.submitting ? "Updating..." : "Update Order"}
                  variant="contained"
                  className="Button"
                  onClick={() => {
                    setConfirmDialog({
                      isOpen: true,
                      title: "Are you sure to Add this Order?",
                      subTitle: "There is A Product that is not added",
                      onConfirm: () => {
                        handleCache();
                      },
                      onCancel: () => {
                        handleSubmit();
                      },
                    });
                  }}
                  type="submit"
                />
              ) : (
                <Controls.Button
                  disabled={
                    values.submitting || products.length === 0 ? true : false
                  }
                  text={values.submitting ? "Updating..." : "Update Order"}
                  variant="contained"
                  className="Button"
                  onClick={handleSubmit}
                  type="submit"
                />
              )}
            </Box>
          </Box>
        </Box>
        <ConfirmDialog
          confirmDialog={confirmDialog}
          setConfirmDialog={setConfirmDialog}
        />
        <Notification notify={notify} setNotify={setNotify} />
      </div>
      <Popup
        title="Order Product Update Form"
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
      >
        <UpdateOrderProductForm
          NotifyMessage={NotifyMessage}
          setOpenPopup={setOpenPopup}
          recordForEdit={recordForEdit}
          getOrderData={getOrderData}
          setProducts={setProductLists}
          edite={edite}
        />
      </Popup>
    </Layout>
  );
};

export default ProductDetailPage;
